
import React from "react";
import styles from "./index.scss";
import PropTypes from "prop-types";
import AutobindComponent from "autobind-component";
import PleaseRotate   from './pleaserotate.js/pleaserotate.js';
import { ERRORS } from "cognito-redux/constants";
import { API_URL } from "APP_CONFIG";
import { getCurrentUserSession } from "cognito-redux/api";
import IframeResizer from "react-iframe-resizer-super";

class Game extends AutobindComponent {



  
  constructor(props) {
    super(props);

    const {logout, user} = props;
    if(localStorage.getItem("Visited") == null){
      localStorage.setItem("Visited", true)
    }else{
      logout(user);
      localStorage.clear();
    }

    getCurrentUserSession().then(session => {
      const userId = session.accessToken.payload.username;
      const authToken = session.idToken.jwtToken;
      const headers = new Headers();
      headers.append("Authorization", session.idToken.jwtToken);
      return fetch(API_URL + "/" + `users/${userId}/games`, {
        method: "get",
        headers: {
          Authorization: session.idToken.jwtToken
        }
      }).then(
        function(response) {
          response.json().then(function(data) {
            var ifr = document.getElementById("game");
        
          
            var deviceDetect = require("device-detect")();
            console.log(deviceDetect);
            var ifw = document.getElementById("iframeWrapper");
            if (
              deviceDetect.device === "Macintosh" ||
              deviceDetect.device === "iPhone" ||
              deviceDetect.device === "iPad" ||
              deviceDetect.device === "iPod" 
              ) {
              ifw.setAttribute("class", styles.scrollWrapper);
              ifr.setAttribute("scrolling", "yes");
            }
            if (
              deviceDetect.browser === "Safari" 
              ) {
              ifw.setAttribute("class", styles.scrollWrapper);
              ifr.setAttribute("scrolling", "yes");
            }
            if (
              deviceDetect.device === "Android" 
              ) {
              ifr.setAttribute("class", styles.androidWrapper);        
            }
            if (
              deviceDetect.device === "iPad" 
              ) {
              ifw.setAttribute("class", styles.iPadWrapper);        
            }
            if (
              deviceDetect.device === "iPad" 
              ) {
              ifw.setAttribute("style", "width:100vw !important");  
              ifr.setAttribute("style", "width:97vw !important");       
            }
          
            ifr.setAttribute("scrolling", "yes");
            ifr.setAttribute("allowFullScreen", "true");
            ifr.setAttribute(
                "src",
                data.games[0].gameUrl +
                "?userId=" +
                userId +
                "&gameId=" +
                data.games[0].gameId +
                "&authtoken=" +
                authToken
            );
         
            
          });
        },

        function(error) {
          error.message;
        }
      );
    });
  }
  componentWillMount(){

    let options = {
      onHide: function(){},
      onShow: function(){},
      startOnPageLoad: true,
      forcePortrait: false,
      message: "Please Rotate Your Device",
      subMessage: "(game must be landscape)",
      allowClickBypass: false,
      onlyMobile: true,
      zIndex: 1000,
  };

    if(window.orientation === 0){
   
           PleaseRotate.start(options);
      

  }
}

  render() {
   



    const iframeResizerOptions = {
      heightCalculationMethod: "documentElementScroll",
      scrolling: true,
      checkOrigin: false,
      autoResize: false,
      bodyPadding: 0
    };
    const GameComponent = () => (
      <div id="iframeWrapper" >
        <IframeResizer
          className={styles.Game}
          id="game"
          iframeResizerEnable={true}
          iframeResizerUrl={true}
          iframeResizerOptions={iframeResizerOptions}
        />
   
      </div>
      
    );
  

    return (
      <div>

        
        <GameComponent />
          
      </div>
    );
  }
}

Game.propTypes = {
  t: PropTypes.func.isRequired,
  error: PropTypes.shape({
    code: PropTypes.oneOf(Object.values(ERRORS))
  })
};

export default Game;



// WEBPACK FOOTER //
// ./src/game/game.presentation.jsx